export default __webpack_public_path__ + "static/media/footer-icon.c1fb046e.png";